import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import DownloadGuide from './components/DownloadGuide';
import CategoryShowcase from './components/CategoryShowcase';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import { siteInfo } from '@/mocks/home';

export default function Home() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: siteInfo.domain,
    description: siteInfo.description,
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'support@008pg.com',
      contactType: 'customer service',
      availableLanguage: ['Chinese', 'English'],
    },
  };

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: siteInfo.domain,
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${siteInfo.domain}/search?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  };

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '008pg国际app官网下载 - 安全正版下载入口',
    description: siteInfo.description,
    url: siteInfo.domain,
    isPartOf: {
      '@type': 'WebSite',
      name: siteInfo.name,
      url: siteInfo.domain,
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webSiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageSchema) }}
      />
      <HeroSection />
      <FeaturesSection />
      <DownloadGuide />
      <CategoryShowcase />
      <LatestArticles />
      <FAQSection />
    </>
  );
}